module.exports = __webpack_public_path__ + "img/towd_3.f0953df3.jpg";